import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { PageMovedPage } from "@pages/page-moved";

export const Route = createFileRoute("/members/$")({
  component: () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const loc = Route.useMatch();

    const wildcard = loc.params._splat;

    console.log(loc.params);
    if (wildcard === "enroll") {
      return <PageMovedPage to="/gs-admin/members/enroll" />;
    }

    if (wildcard === "search") {
      return (
        <PageMovedPage to="/gs-admin/members/search" search={loc.search} />
      );
    }

    return <PageMovedPage />;
  },
});
